import React from 'react';
import { withSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-react';

import BaiduMapComponent from './BaiduMapComponent';
import GoogleMapComponent from './GoogleMapComponent';
import useStyles from './style';
import Hidden from '@material-ui/core/Hidden';
import clsx from 'clsx';
import Button from '../../atoms/Button';
import { get, cloneDeep } from 'lodash';
import {
  LANGUAGE_CODE,
  GOOGLE_DIRECTION_URL,
  BAIDU_DIRECTION_URL,
} from '../../../../constants';
import { pushAnaylyticsData, createDynamicLabels } from '../../../../utils/analytics';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import { isLanguageEqual } from '../../../utils/cookie';
import Typography from '../../atoms/Typography';


const MapViewer = props => {
  const classes = useStyles();
  const { isItinerary = false, showLegend = false, markers: updateMarkers, labels, sitecoreContext, componentName, pageName, itineraryMapUrl } = props;

  const markers = updateMarkers && updateMarkers.filter(item => item && item.lat && item.lng);

  const contentType = get(
    sitecoreContext,
    'route.fields.contentType.fields.taxonomyKey.value',
    ''
  ).toLowerCase();

  const getList = markers && markers.map((marker, i) => (
    <li key={`marker-legend-${i}`}>{marker.name}</li>
  ));

  const getItineraryURLGoogle = () => {
    const markerCopy = cloneDeep(markers);
    const origin = markerCopy && markerCopy.shift();
    const destination = markerCopy && markerCopy.pop();
    const locations = markerCopy && markerCopy
      .map(marker => marker && `${marker.lat},${marker.lng}|`)
      .join('');

    return origin && destination && `${GOOGLE_DIRECTION_URL}?api=1&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&waypoints=${locations}`;
  };

  const getItineraryURLBaidu = () => {
    if (markers && markers.length > 0) {
      return `${BAIDU_DIRECTION_URL}?origin=latlng:${markers[0].lat},${markers[0].lng
        }|name:${markers[0].name}&destination=latlng:${markers[markers.length - 1].lat
        },${markers[markers.length - 1].lng}|name:${markers[markers.length - 1].name
        }&mode=driving&region=none&output=html`;
    }
  };
  const addAnalyticsInfo = () => {

    const obj = {
      ...analyticsData.pageBodyInteraction.viewItineraryMapClick,
      ...{ label: createDynamicLabels([pageName, componentName, get(props, 'sitecoreContext.route.fields.name.value', '')]) },
    };
    pushAnaylyticsData(obj)
  }
  const btnText = <Typography
    variant="body2Bold"
    component="span"
    className={classes.contactPerson}
  >
    <Text field={{
      value: get(
        labels,
        'viewFullItinerary.value',
        ''
      ),
    }} />
  </Typography>;

  return (
    <div className={classes.root}>
      <div className={classes.holder} aria-describedby='addressLabel'>
        <div id='addressLabel' className='sr-only' tabIndex={0}>
          <Typography>Name:{markers[0].name}</Typography>
          <Typography>Address:{markers[0].address}</Typography>
        </div>
        {isLanguageEqual(props.language, LANGUAGE_CODE.CHINESE) ? (
          <BaiduMapComponent {...{ ...props, markers, classes }} componentName={componentName} pageName={pageName} />
        ) : (
          <GoogleMapComponent {...{ ...props, markers, classes }} componentName={componentName} pageName={pageName} contentType={contentType} />
        )}
        {isItinerary && showLegend && !isLanguageEqual(props.language, LANGUAGE_CODE.CHINESE) && (
          <div className={clsx(classes.legends, 'overlay')}>
            {showLegend && (
              <Hidden mdDown implementation="css">
                <ol className={classes.list}>{getList}</ol>
              </Hidden>
            )}
            <Button
              className={classes.directionBtn}
              component="span"
              buttonType="secondary"
              size="small"
              field={{
                value: {
                  text: btnText,
                  href:
                    !isLanguageEqual(props.language, LANGUAGE_CODE.CHINESE)
                      ? getItineraryURLGoogle()
                      : getItineraryURLBaidu(),
                  target: '_blank',
                },
              }}
              isStartIcon={true}
              hasBorder={false}
              rel={'noopener'}
              onClick={addAnalyticsInfo}
            />
          </div>
        )}
        {isItinerary && !showLegend && itineraryMapUrl && !isLanguageEqual(props.language, LANGUAGE_CODE.CHINESE) && (
          <div className={clsx(classes.legends, 'overlay')}>
            <Button
              className={classes.directionBtn}
              component="span"
              buttonType="secondary"
              size="small"
              field={{
                value: {
                  text: btnText,
                  href: itineraryMapUrl,
                  target: '_blank',
                },
              }}
              isStartIcon={true}
              hasBorder={false}
              rel={'noopener'}
              onClick={addAnalyticsInfo}
            />
          </div>
        )}
      </div>
      {isItinerary && showLegend && (
        <Hidden lgUp implementation="css">
          <div className={classes.legends}>
            <ol className={classes.list}>{getList}</ol>
          </div>
        </Hidden>
      )}
    </div>
  );
};

export default withSitecoreContext()(MapViewer);
